module.exports = __webpack_public_path__ + "media/images/sm_icon05-a72563c394b02913bf65dad6f23ae8c7.png";